import { Component, OnInit, ViewChild } from '@angular/core';
import { GridDataResult, DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { State, process, SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { SaveAlumniDetaisService } from '../../@services/alumni-application.service';
import { FilterPipe } from 'ngx-filter-pipe'
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-thank-you-screen',
  templateUrl: './thank-you-screen.component.html',
  styleUrls: ['./thank-you-screen.component.scss'],
  providers: [DatePipe]
})
export class ThankYouScreenComponent implements OnInit {

  public gridView: GridDataResult;
  public gridData: any[] = [];
  public isshow: boolean = false;

  public state: State = {
    skip: 0,
    take: 10
  };
  public sort: SortDescriptor[] = [{
    field: 'FirstName',
    dir: 'asc'
  }];

  constructor(private saveAlumniDetaisService: SaveAlumniDetaisService,
    private filter: FilterPipe, public datepipe: DatePipe) { }

  @ViewChild(GridComponent) grid: GridComponent;

  ngOnInit() {
    // this.getAlumniDuplicateList()
  }

  public ngAfterViewInit(): void {
    // Expand the first row initially
    // var getemail = JSON.parse(localStorage.getItem('duplicateemail'));
    // if (getemail == null) {
    // } else {
    //   this.grid.expandRow(0);
    // }
  }

  getAlumniDuplicateList() {
    var getemail = JSON.parse(localStorage.getItem('duplicateemail'));
    if (getemail == null) {
      this.isshow = false;
    } else {
      this.isshow = true;
      this.saveAlumniDetaisService.getAlumniDuplicateList(getemail.email).subscribe(x => {
        if (x.ServiceStatus == "SUCCESS") {
          x.AlumniList.map((res) => {
            res.GraduatedDate = this.datepipe.transform(res.GraduatedDate, 'MM-yyyy');
            res.ISActive = res.ISActive == 1 ? 'true' : 'false';
          });
          localStorage.removeItem('duplicateemail');
          this.gridData = x.AlumniList;
          this.sortChange(this.sort);
          this.gridView = this.loadItems(this.gridData, this.state);
        }
      }, err => {
      }, () => {
      });
    }

  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.gridView = {
      data: orderBy(this.gridData, sort),
      total: this.gridData.length
    };
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridView = process(this.gridData, this.state);
  }

  private loadItems(gridData: Array<any>, state: State): GridDataResult {
    let gridView: GridDataResult = {
      data: gridData.slice(state.skip, state.skip + state.take),
      total: gridData.length
    };
    return gridView;
  }

  private onSearch(searchStr: string) {
    let filter = { $or: [{ FirstName: searchStr }, { LastName: searchStr }] };
    let result = this.filter.transform(this.gridData, filter);
    this.gridView = this.loadItems(result, this.state);
  }
}
